import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=f7c38f78&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7c38f78')) {
      api.createRecord('f7c38f78', component.options)
    } else {
      api.reload('f7c38f78', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=f7c38f78&", function () {
      api.rerender('f7c38f78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KbbYM7UFpNkf/JS/comp/ImgFallback.vue"
export default component.exports